export const PLAYBACK_RATES = [-5, -2, -1, -0.5, 0.5, 1, 2, 5];
export const NORMAL_SPEED_COLOR = '#f7c315';
export const SPEED_OPTION_COLOR = '#d0d0d0';
export const NORMAL_SPEED_TOP = `${(100 - (PLAYBACK_RATES.indexOf(1) / (PLAYBACK_RATES.length - 1)) * 100).toFixed(3)}%`;
export const CAMERA_SOURCE = process.env.REACT_APP_CAMERA_SOURCE === 'backup' ? 'backup' : 'prod';
export const DEFAULT_QUALITY = 'high';
export const VNC_API_BASE = '/api/v1/vnc';

export const PLAYLIST_MATCH_TOLERANCE_MS = 2_000;
export const PLAYLIST_MATCH_LOOKAHEAD_MS = 10 * 60_000;
export const DVR_WINDOWS_SECONDS = {
  forward: { before: 2, after: 600 },
  backward: { before: 120, after: 480 }
};
export const RECORDING_RANGE_REFRESH_MS = 30_000;
export const DEFAULT_EXPORT_DURATION_MS = 60_000;
export const MAX_EXPORT_DURATION_MS = 24 * 60 * 60_000;
export const EXPORT_POLL_ATTEMPTS = 150;
export const EXPORT_POLL_INTERVAL_MS = 2_000;
export const DOWNLOAD_URL_REVOKE_DELAY_MS = 60_000;
export const EXPORT_DELETE_DELAY_MS = 120_000;
